import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://claritypsiholog.com';

export default function CanonicalUrl() {
  const location = useLocation();
  
  useEffect(() => {
    // Remove existing canonical link if any
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }

    // Create canonical URL
    const canonicalUrl = `${BASE_URL}${location.pathname}`;
    
    // Create and add canonical link
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = canonicalUrl;
    document.head.appendChild(link);

    // Cleanup on unmount
    return () => {
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) {
        canonical.remove();
      }
    };
  }, [location.pathname]);

  return null;
}
